import type { Deck, Slide } from '@/entities/deck'

export enum EmbedType {
  Classic = 'embed_classic',
  Animated = 'embed',
  Partner = 'embed_partner',
}

export interface DeckWithEmbed extends Deck {
  name: string
  embed_type: EmbedType
  embed_name: string | null
  partner_id: string | null
  partner_name: string | null
  start_slide_id?: number | null
  end_slide_id?: number | null
}

export interface DeckEmbed {
  id: string
  type: string
  name: string
  company_id: number
  deck: Deck
  deck_id: number
  end_slide: Slide | null
  end_slide_id: number | null
  start_slide: Slide | null
  start_slide_id: number | null
  partner_id: number | null
  created_at: string
  updated_at: string
}

interface BaseDeckEmbed {
  company_id: number
  download_url: string
  embed_type: EmbedType
  embed_name: string | null
  partner_id: string | null
  partner_name: string | null
  thumbnail: string | null
  name: string
}

export interface VideoEmbed extends BaseDeckEmbed {
  ended_at: string | null
  started_at: string | null
  conference?: {
    company_id: number
    company: {
      name: string
    }
    deck_id: string
  }
}
